import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HeroVideo } from "@/components/HeroVideo";
import { ProblemSection } from "@/components/sections/ProblemSection";
import { WhyNowBand } from "@/components/sections/WhyNowBand";
import { PlatformSection } from "@/components/sections/PlatformSection";
import { TechnologySection } from "@/components/sections/TechnologySection";
import { AISection } from "@/components/sections/AISection";
import { ApplicationsSection } from "@/components/sections/ApplicationsSection";
import { TeamSection } from "@/components/sections/TeamSection";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { useReveal, scrollToId } from "@/hooks/useReveal";

export default function HomePage({ onOpenContact, onRequestDossier }) {
  useReveal();
  const loc = useLocation();

  // Scroll to hash anchor or state-passed scrollTo after navigation
  useEffect(() => {
    if (loc.hash) {
      const id = loc.hash.replace("#", "");
      setTimeout(() => scrollToId(id), 80);
    } else if (loc.state?.scrollTo) {
      setTimeout(() => scrollToId(loc.state.scrollTo), 80);
    } else {
      // Reset to top on home navigation when no hash
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [loc.hash, loc.state, loc.pathname]);

  return (
    <main>
      <HeroVideo />
      <div className="hairline" />
      <ProblemSection />
      <div className="hairline" />
      <WhyNowBand />
      <div className="hairline" />
      <PlatformSection />
      <div className="hairline" />
      <TechnologySection />
      <div className="hairline" />
      <AISection />
      <div className="hairline" />
      <ApplicationsSection />
      <div className="hairline" />
      <TeamSection onRequestDossier={onRequestDossier} />
      <FinalCTA onOpenContact={onOpenContact} />
    </main>
  );
}
